export const OPERATORS_BY_TYPE = {
  string: [
    { value: 'eq', label: 'Equals' },
    { value: 'neq', label: 'Does not equal' },
    { value: 'contains', label: 'Contains' },
    { value: 'startsWith', label: 'Starts with' },
    { value: 'endsWith', label: 'Ends with' }
  ],
  integer: [
    { value: 'eq', label: 'Equals' },
    { value: 'neq', label: 'Does not equal' },
    { value: 'gt', label: 'Greater than' },
    { value: 'gte', label: 'At least' },
    { value: 'lt', label: 'Less than' },
    { value: 'lte', label: 'At most' },
    { value: 'between', label: 'Between' },
    { value: 'notBetween', label: 'Not between' }
  ],
  decimal: [
    { value: 'eq', label: 'Equals' },
    { value: 'neq', label: 'Does not equal' },
    { value: 'gt', label: 'Greater than' },
    { value: 'gte', label: 'At least' },
    { value: 'lt', label: 'Less than' },
    { value: 'lte', label: 'At most' },
    { value: 'between', label: 'Between' },
    { value: 'notBetween', label: 'Not between' }
  ],
  date: [
    { value: 'eq', label: 'On' },
    { value: 'lt', label: 'Before' },
    { value: 'gt', label: 'After' },
    { value: 'between', label: 'Between' },
    { value: 'notBetween', label: 'Not between' }
  ],
  boolean: [
    { value: 'eq', label: 'Is' }
  ]
}

export const RANGE_OPERATORS = new Set(['between', 'notBetween'])

/**
 * Returns a human-readable summary of a filter for display in the active
 * filters list. Includes the column display name, operator label, and value.
 */
export function describeFilter (filter, columnMap) {
  const col = columnMap.get(filter.column)
  const colLabel = col?.displayName || col?.name || filter.column

  if (filter.operator === 'in') {
    const values = Array.isArray(filter.value) ? filter.value : []
    const display = values.join(', ')
    return `${colLabel} is ${display.length > 60 ? display.slice(0, 57) + '...' : display}`
  }

  const operators = OPERATORS_BY_TYPE[col?.dataType || 'string'] || []
  const opDef = operators.find(o => o.value === filter.operator)
  const opLabel = opDef?.label || filter.operator

  if (RANGE_OPERATORS.has(filter.operator) && Array.isArray(filter.value)) {
    return `${colLabel} ${opLabel.toLowerCase()} ${filter.value[0]} and ${filter.value[1]}`
  }

  const isStringType = col?.dataType === 'string' || (!col?.dataType && typeof filter.value === 'string')
  const displayValue = isStringType ? `"${filter.value}"` : filter.value
  return `${colLabel} ${opLabel.toLowerCase()} ${displayValue}`
}
